<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  <div class='sheet'>
    <h1 class='header'>Copy Order</h1>
    <app-audit-line [data]='this.order'></app-audit-line>
    <form method='post' (ngSubmit)='this.onSubmit()'>
      <app-order-form [isCopy]="true" [materialUplifts]='this.materialUplifts' [account]='this.order.account' [site]='this.order.site' [order]='this.order' [orderLines]='this.orderLines'></app-order-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/orders'>Cancel</button>
    </form>
  </div>
</div>
